(function() {
  'use strict';
  
  var PRODUCT_CONFIG = {
    'english-x-likes': { minPerPost: 10, label: 'لايكات' },
    'arab-x-like': { minPerPost: 20, label: 'لايكات' },
    'arab-retwet': { minPerPost: 50, label: 'ريتويت' },
    'twitter-retweet': { minPerPost: 50, label: 'ريتويت' },
    'x-video-views': { minPerPost: 100, label: 'مشاهدة' }
  };
  
  var API_BASE = 'https://abshrboost.com';
  var INITIAL_TWEETS = 2;
  var LOAD_MORE_COUNT = 3;
  
  var currentPath = window.location.pathname;
  var currentProduct = null;
  
  for (var handle in PRODUCT_CONFIG) {
    if (currentPath.includes('/products/' + handle)) {
      currentProduct = {
        handle: handle,
        minPerPost: PRODUCT_CONFIG[handle].minPerPost,
        label: PRODUCT_CONFIG[handle].label
      };
      break;
    }
  }
  
  if (!currentProduct) return;
  
  var allTweets = [];
  var visibleCount = INITIAL_TWEETS;
  var selectedTweets = [];
  var directLink = '';
  
  function arabicToWestern(str) {
    var arabicNumerals = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
    var result = str;
    for (var i = 0; i < 10; i++) {
      result = result.replace(new RegExp(arabicNumerals[i], 'g'), i.toString());
    }
    return result;
  }
  
  function getSelectedQuantity() {
    var variantSelect = document.querySelector('#option-0, select.select__select, select[name="id"], .product__variants select, select.single-option-selector');
    if (variantSelect && variantSelect.selectedOptions && variantSelect.selectedOptions[0]) {
      var text = variantSelect.selectedOptions[0].text || variantSelect.selectedOptions[0].value || '';
      var westernText = arabicToWestern(text);
      var match = westernText.match(/(\d+)/);
      if (match) return parseInt(match[1], 10);
    }
    return 0;
  }
  
  function createWidget() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    
    var selectedPostsInput = document.createElement('input');
    selectedPostsInput.type = 'hidden';
    selectedPostsInput.name = 'properties[selected_posts]';
    selectedPostsInput.id = 'tw-selected-posts-input';
    selectedPostsInput.value = '';
    form.appendChild(selectedPostsInput);
    
    var quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'properties[total_quantity]';
    quantityInput.id = 'tw-quantity-input';
    quantityInput.value = '';
    form.appendChild(quantityInput);
    
    var perPostInput = document.createElement('input');
    perPostInput.type = 'hidden';
    perPostInput.name = 'properties[per_post]';
    perPostInput.id = 'tw-per-post-input';
    perPostInput.value = '';
    form.appendChild(perPostInput);
    
    interceptAjaxCart();
    
    var container = document.createElement('div');
    container.innerHTML = '\
<div id="twitter-post-selector" style="margin:20px 0;padding:20px;border:1px solid #e0e0e0;border-radius:12px;background:linear-gradient(135deg,#1da1f210,#14171a10);direction:rtl;max-width:400px;">\
<style>\
#twitter-post-selector h3{margin:0 0 15px 0;font-size:18px;color:#333;display:flex;align-items:center;gap:8px;}\
#twitter-post-selector .tw-section{margin-bottom:15px;padding:15px;background:#fff;border-radius:10px;border:1px solid #e0e0e0;}\
#twitter-post-selector .tw-section.active{border-color:#1da1f2;box-shadow:0 0 10px rgba(29,161,242,0.2);}\
#twitter-post-selector .tw-section-title{font-size:15px;font-weight:bold;color:#333;margin-bottom:8px;display:flex;align-items:center;gap:6px;}\
#twitter-post-selector .tw-section-note{font-size:12px;color:#666;margin-bottom:12px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;}\
#twitter-post-selector .tw-divider{text-align:center;margin:15px 0;color:#999;font-size:14px;position:relative;}\
#twitter-post-selector .tw-divider:before,#twitter-post-selector .tw-divider:after{content:"";position:absolute;top:50%;width:40%;height:1px;background:#ddd;}\
#twitter-post-selector .tw-divider:before{right:0;}\
#twitter-post-selector .tw-divider:after{left:0;}\
#twitter-post-selector .tw-input{width:100%;padding:12px;border:1px solid #ddd;border-radius:8px;font-size:14px;direction:ltr;box-sizing:border-box;background:#fff;}\
#twitter-post-selector .tw-input:focus{border-color:#1da1f2;outline:none;}\
#twitter-post-selector .tw-btn{margin-top:10px;width:100%;padding:12px;background:linear-gradient(135deg,#1da1f2,#0d8ecf);color:white;border:none;border-radius:8px;cursor:pointer;font-weight:bold;font-size:14px;}\
#twitter-post-selector .tw-btn:disabled{background:#ccc;cursor:not-allowed;}\
#twitter-post-selector .tw-expand-btn{width:100%;padding:14px;background:#f8f9fa;color:#333;border:1px solid #ddd;border-radius:10px;cursor:pointer;font-weight:bold;font-size:14px;display:flex;align-items:center;justify-content:center;gap:8px;transition:all 0.2s;}\
#twitter-post-selector .tw-expand-btn:hover{background:#e9ecef;border-color:#ccc;}\
#twitter-post-selector .tw-expand-btn.active{background:#fff;border-color:#1da1f2;box-shadow:0 0 10px rgba(29,161,242,0.2);}\
#twitter-post-selector .tw-expand-btn .arrow{transition:transform 0.3s;}\
#twitter-post-selector .tw-expand-btn.active .arrow{transform:rotate(180deg);}\
#twitter-post-selector .tw-expandable{display:none;margin-top:15px;padding:15px;background:#fff;border-radius:10px;border:1px solid #1da1f2;}\
#twitter-post-selector .tw-expandable.open{display:block;}\
#twitter-post-selector .tw-cancel-btn{padding:4px 10px;background:#f8d7da;color:#721c24;border:none;border-radius:4px;cursor:pointer;font-size:12px;}\
#twitter-post-selector .tw-cancel-btn:hover{background:#f5c6cb;}\
#twitter-post-selector .tw-loading{display:none;text-align:center;padding:20px;color:#666;}\
#twitter-post-selector .tw-error{display:none;background:#f8d7da;color:#721c24;padding:10px;border-radius:6px;margin-top:10px;text-align:center;font-size:13px;}\
#twitter-post-selector .tw-success{display:none;background:#d4edda;color:#155724;padding:10px;border-radius:6px;margin-top:10px;text-align:center;font-size:13px;}\
#twitter-post-selector .tw-grid{display:none;flex-direction:column;gap:10px;margin-top:15px;}\
#twitter-post-selector .tw-tweet{position:relative;border-radius:10px;overflow:hidden;cursor:pointer;padding:12px;border:2px solid #e0e0e0;background:#fff;transition:all 0.2s;}\
#twitter-post-selector .tw-tweet.selected{border-color:#1da1f2;background:#f0f9ff;box-shadow:0 0 10px rgba(29,161,242,0.3);}\
#twitter-post-selector .tw-tweet.disabled{opacity:0.4;cursor:not-allowed;}\
#twitter-post-selector .tw-tweet-text{font-size:13px;color:#14171a;line-height:1.4;margin-bottom:8px;direction:ltr;text-align:left;}\
#twitter-post-selector .tw-tweet-stats{display:flex;gap:12px;font-size:11px;color:#657786;direction:ltr;}\
#twitter-post-selector .tw-tweet-stats span{display:flex;align-items:center;gap:3px;}\
#twitter-post-selector .tw-tweet .tw-check{position:absolute;top:8px;right:8px;width:24px;height:24px;background:#1da1f2;border-radius:50%;display:none;align-items:center;justify-content:center;color:white;font-size:12px;z-index:10;}\
#twitter-post-selector .tw-tweet.selected .tw-check{display:flex;}\
#twitter-post-selector .tw-tweet .tw-badge{position:absolute;bottom:8px;right:8px;background:#1da1f2;color:#fff;padding:3px 8px;border-radius:4px;font-size:11px;font-weight:bold;display:none;z-index:10;}\
#twitter-post-selector .tw-tweet.selected .tw-badge{display:block;}\
#twitter-post-selector .tw-selection-info{display:none;margin-top:10px;padding:10px;background:#f8f9fa;border-radius:6px;font-size:13px;}\
#twitter-post-selector .tw-warning{display:none;background:#fff3cd;color:#856404;padding:8px;border-radius:6px;margin-top:10px;font-size:12px;}\
#twitter-post-selector .tw-load-more{display:none;width:100%;padding:8px;background:#f0f0f0;border:none;border-radius:6px;cursor:pointer;margin-top:10px;font-size:13px;}\
</style>\
\
<h3>\
<svg width="24" height="24" viewBox="0 0 24 24" fill="#1da1f2"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>\
اختر طريقة الإرسال\
</h3>\
\
<div id="tw-direct-section" class="tw-section">\
<div class="tw-section-title">🔗 رابط مباشر</div>\
<div class="tw-section-note"><span>يمكنك إضافة رابط التغريدة مباشرة</span></div>\
<input type="text" id="tw-direct-link" class="tw-input" placeholder="رابط التغريدة">\
<div id="tw-direct-success" class="tw-success">✓ تم إضافة الرابط - يمكنك الآن الإضافة للسلة</div>\
</div>\
\
<div class="tw-divider">أو</div>\
\
<button type="button" id="tw-expand-btn" class="tw-expand-btn">\
<span>📱 توزيع على التغريدات</span>\
<span class="arrow">▼</span>\
</button>\
\
<div id="tw-select-section" class="tw-expandable">\
<div class="tw-section-note"><span id="tw-note-text">أدخل اسم المستخدم واختر التغريدات لتوزيع ال' + currentProduct.label + ' عليها</span><button type="button" id="tw-cancel-btn" class="tw-cancel-btn" style="display:none;">إلغاء</button></div>\
<div id="tw-input-section">\
<input type="text" id="tw-username" class="tw-input" placeholder="أكتب اليوزر نيم واضغط على تحميل التغريدات">\
<button type="button" id="tw-load-btn" class="tw-btn">تحميل التغريدات</button>\
</div>\
<div id="tw-loading" class="tw-loading">جاري تحميل التغريدات...</div>\
<div id="tw-error" class="tw-error"></div>\
<div id="tw-grid" class="tw-grid"></div>\
<button type="button" id="tw-load-more" class="tw-load-more">تحميل المزيد</button>\
<div id="tw-selection-info" class="tw-selection-info">\
تم اختيار: <strong><span id="tw-selected-count">0</span></strong> من أصل <strong><span id="tw-max-posts">0</span></strong> تغريدة\
<span id="tw-per-post-text" style="display:none;"> | <span id="tw-per-post">0</span> ' + currentProduct.label + ' لكل تغريدة</span>\
</div>\
<div id="tw-warning" class="tw-warning">وصلت للحد الأقصى من التغريدات المسموحة</div>\
<div id="tw-select-success" class="tw-success">✓ تم اختيار التغريدات - يمكنك الآن الإضافة للسلة</div>\
</div>\
\
</div>';
    
    var insertPoint = document.querySelector('#infiniteoptions-container');
    if (!insertPoint) {
      insertPoint = document.querySelector('.productView-options, .productView-variants, .product__variants');
    }
    if (insertPoint) {
      insertPoint.parentNode.insertBefore(container, insertPoint.nextSibling);
    } else {
      form.parentNode.insertBefore(container, form.nextSibling);
    }
    
    var expandBtn = document.getElementById('tw-expand-btn');
    var selectSection = document.getElementById('tw-select-section');
    
    expandBtn.addEventListener('click', function() {
      var isOpen = selectSection.classList.contains('open');
      if (isOpen) {
        selectSection.classList.remove('open');
        expandBtn.classList.remove('active');
      } else {
        selectSection.classList.add('open');
        expandBtn.classList.add('active');
        if (allTweets.length > 0 || selectedTweets.length > 0) {
          document.getElementById('tw-direct-section').style.opacity = '0.5';
          document.getElementById('tw-direct-section').style.pointerEvents = 'none';
        }
      }
    });
    
    var directLinkInput = document.getElementById('tw-direct-link');
    directLinkInput.addEventListener('input', handleDirectLinkChange);
    directLinkInput.addEventListener('change', handleDirectLinkChange);
    
    function handleDirectLinkChange() {
      var link = directLinkInput.value.trim();
      
      var urlMatch = link.match(/(https?:\/\/[^\s]+)/);
      if (urlMatch) {
        link = urlMatch[1];
        directLinkInput.value = link;
      }
      
      var directSection = document.getElementById('tw-direct-section');
      var directSuccess = document.getElementById('tw-direct-success');
      
      if (link.length > 0 && (link.includes('twitter.com') || link.includes('x.com'))) {
        directLink = link;
        directSection.classList.add('active');
        expandBtn.style.opacity = '0.5';
        expandBtn.style.pointerEvents = 'none';
        selectSection.classList.remove('open');
        expandBtn.classList.remove('active');
        directSuccess.style.display = 'block';
        
        selectedTweets = [];
        updateInputs();
        
        document.getElementById('tw-selected-posts-input').value = link;
        var qty = getSelectedQuantity();
        document.getElementById('tw-quantity-input').value = qty.toString();
        document.getElementById('tw-per-post-input').value = qty.toString();
        
        window.__twWidgetData = {
          selected_posts: link,
          total_quantity: qty.toString(),
          per_post: qty.toString()
        };
      } else {
        directLink = '';
        directSection.classList.remove('active');
        expandBtn.style.opacity = '1';
        expandBtn.style.pointerEvents = 'auto';
        directSuccess.style.display = 'none';
        
        if (selectedTweets.length === 0) {
          document.getElementById('tw-selected-posts-input').value = '';
          document.getElementById('tw-quantity-input').value = '';
          document.getElementById('tw-per-post-input').value = '';
          window.__twWidgetData = null;
        }
      }
    }
    
    function updateMaxPosts() {
      var qty = getSelectedQuantity();
      var maxPosts = qty > 0 ? Math.floor(qty / currentProduct.minPerPost) : 0;
      document.getElementById('tw-max-posts').textContent = maxPosts;
      return maxPosts;
    }
    
    updateMaxPosts();
    
    var variantSelect = document.querySelector('#option-0, select.select__select, select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        updateMaxPosts();
        if (allTweets.length > 0) renderTweets();
        updateInputs();
        handleDirectLinkChange();
      });
    }
    
    var addToCartBtn = document.querySelector('button[type="submit"], .productView-options-submit, .add-to-cart, button[name="add"]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        var hasDirectLink = directLink.length > 0 && (directLink.includes('twitter.com') || directLink.includes('x.com'));
        var hasSelectedTweets = selectedTweets.length > 0;
        
        if (!hasDirectLink && !hasSelectedTweets) {
          e.preventDefault();
          e.stopPropagation();
          alert('يرجى إضافة رابط التغريدة أو اختيار تغريدات من الأداة أولاً');
          
          var widget = document.getElementById('twitter-post-selector');
          if (widget) {
            widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
            widget.style.boxShadow = '0 0 20px rgba(29,161,242,0.5)';
            setTimeout(function() { widget.style.boxShadow = 'none'; }, 2000);
          }
          return false;
        }
      }, true);
    }
    
    document.getElementById('tw-load-btn').addEventListener('click', loadTweets);
    document.getElementById('tw-load-more').addEventListener('click', function() {
      visibleCount += LOAD_MORE_COUNT;
      renderTweets();
    });
    
    document.getElementById('tw-cancel-btn').addEventListener('click', function() {
      allTweets = [];
      selectedTweets = [];
      visibleCount = INITIAL_TWEETS;
      
      document.getElementById('tw-input-section').style.display = 'block';
      document.getElementById('tw-grid').style.display = 'none';
      document.getElementById('tw-grid').innerHTML = '';
      document.getElementById('tw-selection-info').style.display = 'none';
      document.getElementById('tw-warning').style.display = 'none';
      document.getElementById('tw-load-more').style.display = 'none';
      document.getElementById('tw-select-success').style.display = 'none';
      document.getElementById('tw-username').value = '';
      
      document.getElementById('tw-note-text').textContent = 'أدخل اسم المستخدم واختر التغريدات لتوزيع ال' + currentProduct.label + ' عليها';
      document.getElementById('tw-cancel-btn').style.display = 'none';
      
      document.getElementById('tw-direct-section').style.opacity = '1';
      document.getElementById('tw-direct-section').style.pointerEvents = 'auto';
      
      document.getElementById('tw-selected-posts-input').value = '';
      document.getElementById('tw-quantity-input').value = '';
      document.getElementById('tw-per-post-input').value = '';
      window.__twWidgetData = null;
    });
    
    function loadTweets() {
      var username = document.getElementById('tw-username').value.trim().replace('@', '');
      if (!username) {
        showError('الرجاء إدخال اسم المستخدم');
        return;
      }
      
      hideError();
      document.getElementById('tw-loading').style.display = 'block';
      document.getElementById('tw-load-btn').disabled = true;
      
      fetch(API_BASE + '/api/public/twitter/tweets?username=' + encodeURIComponent(username))
        .then(function(response) { return response.json(); })
        .then(function(data) {
          document.getElementById('tw-loading').style.display = 'none';
          document.getElementById('tw-load-btn').disabled = false;
          
          if (data.success && data.tweets && data.tweets.length > 0) {
            allTweets = data.tweets;
            visibleCount = INITIAL_TWEETS;
            selectedTweets = [];
            document.getElementById('tw-input-section').style.display = 'none';
            document.getElementById('tw-grid').style.display = 'flex';
            document.getElementById('tw-selection-info').style.display = 'block';
            
            document.getElementById('tw-note-text').textContent = 'اختر التغريدات التي تريد توزيع ال' + currentProduct.label + ' عليها';
            document.getElementById('tw-cancel-btn').style.display = 'inline-block';
            
            document.getElementById('tw-direct-section').style.opacity = '0.5';
            document.getElementById('tw-direct-section').style.pointerEvents = 'none';
            
            renderTweets();
          } else {
            showError(data.error || 'لم يتم العثور على تغريدات');
          }
        })
        .catch(function() {
          document.getElementById('tw-loading').style.display = 'none';
          document.getElementById('tw-load-btn').disabled = false;
          showError('خطأ في تحميل التغريدات - حاول مرة أخرى');
        });
    }
    
    function formatNumber(num) {
      if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
      if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
      return num.toString();
    }
    
    function renderTweets() {
      var grid = document.getElementById('tw-grid');
      var maxPosts = updateMaxPosts();
      var atLimit = selectedTweets.length >= maxPosts;
      
      grid.innerHTML = '';
      var tweetsToShow = allTweets.slice(0, visibleCount);
      
      tweetsToShow.forEach(function(tweet) {
        var isSelected = selectedTweets.indexOf(tweet.url) > -1;
        var isDisabled = !isSelected && atLimit;
        
        var div = document.createElement('div');
        div.className = 'tw-tweet' + (isSelected ? ' selected' : '') + (isDisabled ? ' disabled' : '');
        div.dataset.url = tweet.url;
        div.innerHTML = '\
          <div class="tw-check">✓</div>\
          <div class="tw-tweet-text">' + escapeHtml(tweet.text) + '</div>\
          <div class="tw-tweet-stats">\
            <span>❤️ ' + formatNumber(tweet.likes || 0) + '</span>\
            <span>🔁 ' + formatNumber(tweet.retweets || 0) + '</span>\
            <span>💬 ' + formatNumber(tweet.replies || 0) + '</span>\
            <span>👁 ' + formatNumber(tweet.views || 0) + '</span>\
          </div>\
          <div class="tw-badge">+<span class="tw-tweet-count">0</span></div>';
        div.onclick = function() { toggleTweet(div, tweet.url); };
        grid.appendChild(div);
      });
      
      var loadMoreBtn = document.getElementById('tw-load-more');
      loadMoreBtn.style.display = visibleCount >= allTweets.length ? 'none' : 'block';
      if (visibleCount < allTweets.length) {
        loadMoreBtn.textContent = 'تحميل المزيد (' + (allTweets.length - visibleCount) + ' متبقي)';
      }
      
      document.getElementById('tw-warning').style.display = atLimit ? 'block' : 'none';
      updateInputs();
    }
    
    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
    
    function toggleTweet(el, url) {
      if (el.classList.contains('disabled')) return;
      
      var index = selectedTweets.indexOf(url);
      if (index > -1) {
        selectedTweets.splice(index, 1);
      } else {
        var maxPosts = updateMaxPosts();
        if (selectedTweets.length >= maxPosts) return;
        selectedTweets.push(url);
      }
      
      renderTweets();
    }
    
    function updateInputs() {
      var qty = getSelectedQuantity();
      document.getElementById('tw-selected-count').textContent = selectedTweets.length;
      var selectSuccess = document.getElementById('tw-select-success');
      
      if (selectedTweets.length > 0 && qty >= currentProduct.minPerPost) {
        var perPost = Math.floor(qty / selectedTweets.length);
        document.getElementById('tw-per-post').textContent = perPost;
        document.getElementById('tw-per-post-text').style.display = 'inline';
        
        document.getElementById('tw-selected-posts-input').value = selectedTweets.join(',');
        document.getElementById('tw-quantity-input').value = qty.toString();
        document.getElementById('tw-per-post-input').value = perPost.toString();
        
        window.__twWidgetData = {
          selected_posts: selectedTweets.join(','),
          total_quantity: qty.toString(),
          per_post: perPost.toString()
        };
        
        document.querySelectorAll('.tw-tweet.selected .tw-tweet-count').forEach(function(el) {
          el.textContent = perPost;
        });
        
        selectSuccess.style.display = 'block';
      } else {
        document.getElementById('tw-per-post-text').style.display = 'none';
        selectSuccess.style.display = 'none';
        
        if (directLink.length === 0) {
          document.getElementById('tw-selected-posts-input').value = '';
          document.getElementById('tw-quantity-input').value = '';
          document.getElementById('tw-per-post-input').value = '';
          window.__twWidgetData = null;
        }
      }
    }
    
    function showError(msg) {
      var el = document.getElementById('tw-error');
      el.textContent = msg;
      el.style.display = 'block';
    }
    
    function hideError() {
      document.getElementById('tw-error').style.display = 'none';
    }
  }
  
  function interceptAjaxCart() {
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      if (url && (url.includes('/cart/add') || url.includes('/cart/add.js'))) {
        if (window.__twWidgetData && options && options.body) {
          try {
            var body;
            if (typeof options.body === 'string') {
              body = JSON.parse(options.body);
            } else if (options.body instanceof FormData) {
              options.body.append('properties[selected_posts]', window.__twWidgetData.selected_posts);
              options.body.append('properties[total_quantity]', window.__twWidgetData.total_quantity);
              options.body.append('properties[per_post]', window.__twWidgetData.per_post);
              return originalFetch.call(this, url, options);
            } else {
              body = options.body;
            }
            if (body) {
              if (!body.properties) body.properties = {};
              body.properties.selected_posts = window.__twWidgetData.selected_posts;
              body.properties.total_quantity = window.__twWidgetData.total_quantity;
              body.properties.per_post = window.__twWidgetData.per_post;
              options.body = JSON.stringify(body);
            }
          } catch (e) {}
        }
      }
      return originalFetch.call(this, url, options);
    };
    
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    
    XMLHttpRequest.prototype.open = function(method, url) {
      this._twUrl = url;
      return originalOpen.apply(this, arguments);
    };
    
    XMLHttpRequest.prototype.send = function(body) {
      if (this._twUrl && (this._twUrl.includes('/cart/add') || this._twUrl.includes('/cart/add.js'))) {
        if (window.__twWidgetData && body) {
          try {
            var parsed = JSON.parse(body);
            if (!parsed.properties) parsed.properties = {};
            parsed.properties.selected_posts = window.__twWidgetData.selected_posts;
            parsed.properties.total_quantity = window.__twWidgetData.total_quantity;
            parsed.properties.per_post = window.__twWidgetData.per_post;
            body = JSON.stringify(parsed);
          } catch (e) {}
        }
      }
      return originalSend.call(this, body);
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createWidget);
  } else {
    createWidget();
  }
})();